const KMonth = [
    {id: "0", value: "本月"},    
    {id: "1", value: "1個月前"},
    {id: "2", value: "2個月前"},
    {id: "3", value: "3個月前"},
    {id: "4", value: "4個月前"},
  ];  
  
  export default KMonth  